import React from 'react';
import ajax from '../../ajax';
import functions from '../../functions';
import DashCard from '../Common/DashCard';


class WalletBalance extends React.Component {
  
  state={
    userId:functions.sessionGuard(),
    accessInfo:false,
    balance:'...',
    total:'...'
   
  }


    async componentDidMount()
    {
      await this.getActualBalance();
      await this.getCummBalance();
      this.timerActual = setTimeout(this.func1=async()=> {
        await this.getActualBalance();
        this.timerActual = setTimeout(this.func1, 2000); // (*)
      }, 2000);

      this.timerCumm = setTimeout(this.func2=async()=> {
        await this.getCummBalance();
        this.timerCumm = setTimeout(this.func2, 2000); // (*)
      }, 2000);
    }

    componentWillUnmount()
    {
      clearTimeout(this.timerActual);
      clearTimeout(this.timerCumm);
    }

    getActualBalance=async()=>{
      const server_response=await ajax.countWallet(this.state.userId);
      if(server_response.status==="OK")
      {
        this.setState({
          balance:server_response.details.amount_c
        })
      }
    }


    getCummBalance=async()=>{
        const server_response=await ajax.cummWalletBalance(this.state.userId);
        if(server_response.status==="OK")
        {
          this.setState({
            total:server_response.details.amount_c
          })
        }
      }




      readUser=async()=>
      {
          const server_reponse=await ajax.getUserAccess(this.state.userId);
          if(server_reponse.status==="OK")
          {
              this.setState({
                accessInfo:server_reponse.details.list,
              })
          }
      }




  render(){
    
      return (
        <DashCard 
            title="Wallet Balance"
            value={this.state.balance}
            caption={"Cumm. Ugx: " + this.state.total}
            icon={"fas fa-chart-bar text-warning"}
            href="/finance/wallet"
            />

      );
    
 
  }
}

export default WalletBalance;